import React from "react";
type SVGDirectionProps = { className?: string };
const SVGDirection: React.FC<SVGDirectionProps> = (props) => (
	<svg
		width="32"
		height="41"
		viewBox="0 0 32 41"
		fill="none"
		className={props?.className}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16 32.1667C19.958 32.1667 23.1667 28.958 23.1667 25C23.1667 21.042 19.958 17.8333 16 17.8333C12.042 17.8333 8.83334 21.042 8.83334 25C8.83334 28.958 12.042 32.1667 16 32.1667Z"
			fill="#101828"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21.9066 10.1256L16 0L10.0934 10.1256C4.18032 12.4756 0 18.2496 0 25C0 33.8366 7.16344 41 16 41C24.8366 41 32 33.8366 32 25C32 18.2496 27.8197 12.4756 21.9066 10.1256ZM16 37.5C22.9036 37.5 28.5 31.9036 28.5 25C28.5 18.0964 22.9036 12.5 16 12.5C9.09644 12.5 3.5 18.0964 3.5 25C3.5 31.9036 9.09644 37.5 16 37.5Z"
			fill="#101828"
		/>
	</svg>
);
export default SVGDirection;
